var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    id: "qr-scan",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B7AFF",
    d: "M9 4H8C5.79086 4 4 5.79086 4 8V9C4.27614 9.27614 4.72386 9.27614 5 9V8C5 6.34315 6.34315 5 8 5H9C9.27614 4.72386 9.27614 4.27614 9 4zM9 19H8C6.34315 19 5 17.6569 5 16V15C4.72386 14.7239 4.27614 14.7239 4 15V16C4 18.2091 5.79086 20 8 20H9C9.27614 19.7239 9.27614 19.2761 9 19zM15 20C14.7239 19.7239 14.7239 19.2761 15 19H16C17.6569 19 19 17.6569 19 16V15C19.2761 14.7239 19.7239 14.7239 20 15V16C20 18.2091 18.2091 20 16 20H15zM15 5C14.7239 4.72386 14.7239 4.27614 15 4H16C18.2091 4 20 5.79086 20 8V9C19.7239 9.27614 19.2761 9.27614 19 9V8C19 6.34315 17.6569 5 16 5H15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3DEFE",
    d: "M7 9C7 7.89543 7.89543 7 9 7H15C16.1046 7 17 7.89543 17 9V15C17 16.1046 16.1046 17 15 17H9C7.89543 17 7 16.1046 7 15V9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0B7AFF",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M2 12H22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/qr-scan.86116d6f2e2ccd66f9cef4c59ae56427.svg";
export { ForwardRef as ReactComponent };